import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Box, Chip, CircularProgress, Grid, Paper, TextField, MenuItem, Typography, Autocomplete } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { useSelector, useDispatch } from 'react-redux'
import { setMyBalance, setMyShifts, setMyShiftsDate } from '../../store/myShiftsReducer'
import { setDashboardShifts, setDashboardAbsentReason } from '../../store/dashboardReducer'
import ApiService from '../../functions/apiService';
import { useSnackbar } from 'notistack';
import AuthContext from '../../context/AuthContext';
import { useForm } from 'react-hook-form';
import moment from 'moment/moment';
import ManagementHeaderNav from '../../components/HeadersNav/ManagementHeaderNav';
import { useNavigate, useSearchParams } from 'react-router-dom';
import MyTable from "../../components/Schedule/MyTable";
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { toast } from 'react-toastify';
import { DataGrid } from '@mui/x-data-grid';
import EmptyState from '../../components/Error/EmptyState';
import { formateDate, varFormatTime } from '../../utils/helperFunctions';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteConfirmation from '../../components/DeleteModal/DeleteModal';
import Modal from 'react-bootstrap/Modal';
import '../../components/Layout/layout.css';

export default function MyShifts() {
  let navigate = useNavigate();
  const { user, pages, permission } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const date = useSelector((state) => state.myShiftsReducer.Date)
  const shifts = useSelector((state) => state.dashboardReducer.Shifts)
  const abscentReasons = useSelector((state) => state.dashboardReducer.AbsentReason)
  const [summarySearch, setSummarySearch] = useState("");
  const [data, setData] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const routeDate = searchParams.get('date');
  const [saving, setSaving] = useState(false);
  const [otherUsers, setOtherUsers] = useState([])
  const [allowedShifts, setAllowedShifts] = useState([])
  const [isErrorTime, setIsErrorTime] = useState(false)
  const [customData, setCustomData] = useState(false);
  const [startTime, setStartTime] = useState(null)
  const [endTime, setEndTime] = useState(null)
  const [canSubmit, setCanSubmit] = useState(false)
  const [selectedTab, setSelectedTab] = useState("current");
  const [rtoData, setRtoData] = useState([]);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [deleteBody, setDeleteBody] = useState({});
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [selectedComment, setSelectedComment] = useState('');
  const [absentReasonDeatils, setAbsentReasonDetails] = useState([])


  useEffect(() => {
    ApiService.get("/absentCodesAvailability")
      .then(({ data }) => {
        setAbsentReasonDetails(data?.data)
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  }, []);


  const handleShow = (comment) => {
    setShow(true);
    setSelectedComment(comment);
  }

  const { register, formState: { errors, isDirty, isValid }, handleSubmit, setError, getValues, watch, setValue } = useForm({
    defaultValues: {
      ShiftCode: '',
      SelAbsent: '',
      SelEmp: ''
    }
  });
  const dispatch = useDispatch()

  // const { enqueueSnackbar } = useSnackbar();

  const loadData = (dateInput = '') => {
    setLoading(true)
    let Query = dateInput != '' ? '?month=' + (dateInput.getMonth() + 1) + '&year=' + dateInput.getFullYear() : ''
    ApiService.get('/myShifts' + Query, {}, 'myShifts').then(({ data }) => {
      dispatch(setMyShifts(data.MySchedule));
      if (data.MyBalance) {
        dispatch(setMyBalance(Object.values(data.MyBalance)));
      }
      setLoading(false)
    }).catch(() => {
      setLoading(false)
      toast.error("Error")
      // enqueueSnackbar('Error', { variant: 'error' });
    })
  }

  const loadDropDowns = () => {

    ApiService.get('/shiftTypes').then(({ data }) => {
      dispatch(setDashboardShifts(data.data));
    }).catch(() => {
      toast.error("Error")
      // enqueueSnackbar('Error', { variant: 'error' });
    })

    ApiService.get('/absentCodes').then(({ data }) => {
      dispatch(setDashboardAbsentReason(data.data));
    })
      .catch(() => {
        toast.error("Error")
        // enqueueSnackbar('Error', { variant: 'error' });
      });

    ApiService.get('/employeeToSwap').then(({ data }) => {
      const filteredData = data
        .filter(u => u.Emp_Code !== user.Emp_Code)
      setOtherUsers(filteredData)
    }).catch(() => {
      toast.error("Error")
      // enqueueSnackbar('Error', { variant: 'error' });
    })
  }

  useEffect(() => {
    if (routeDate) {
      loadData(new Date(routeDate))
    } else {
      loadData()
    }
    loadDropDowns()
  }, [])

  useEffect(() => {
    if (user.employee_assignment.Group_Code.includes("DAY")) {
      setAllowedShifts(shifts.filter((i) => i.ShiftCode == 2))
    } else {
      setAllowedShifts(shifts)
    }
  }, [shifts])

  const changeDate = (date) => {
    dispatch(setMyShiftsDate(date));
  }
  watch('SelAbsent')

  const onSubmit = (e) => {
    const selectedAbsent = e.SelAbsent;
    const available = absentReasonDeatils?.[selectedAbsent]?.SO_Info?.data?.available;
    const allowedNegative = absentReasonDeatils?.[selectedAbsent]?.SO_Info?.allowed_negative;

    if (available === 0 && !allowedNegative) {
      setSaving(false);
      toast.error(`${abscentReasons[selectedAbsent]} is not available , Zero PTO Balance`);
      return;
    }

    setSaving(true)
    var start = ''
    var end = ''
    if (customData) {
      start = startTime.toString().split(' ')[4]
      end = endTime.toString().split(' ')[4]
    }
    else {
      start = shifts.filter(item => item.ShiftCode == e.ShiftCode)[0].Start_Time
      end = shifts.filter(item => item.ShiftCode == e.ShiftCode)[0].End_Time
    }
    const body = {
      "EmpCode": user.Emp_Code,
      "RequestDate": moment(date).format('YYYY-MM-DD'),
      "ShiftCode": customData ? 91 : e.ShiftCode,
      "SelAbsent": e.SelAbsent,
      "StartTime": start,
      "EndTime": end,
      "SelEmp": e.SelEmp,
      "Comment": e.comment
    }
    ApiService.post('/requestPTO', body)
      .then((data) => {
        setSaving(false)
        toast.success(data?.Message)
        // enqueueSnackbar('success', { variant: 'success' });
        loadData();
        navigate('/firehouse/my-shifts');
      })
      .catch(({ data }) => {
        setSaving(false)
        toast.error(data?.message || data)
        // console.log('err', data);
      })
  }

  const RtoDataList = (() => {
    ApiService.get("/getMyRTOs?filter=" + selectedTab)
      .then(({ data }) => {
        setLoading(false);
        const formattedData = data?.data?.map((row, index) => ({
          ...row,
          id: index + 1,
        }));
        setRtoData(formattedData);
      })
      .catch((error) => {
        setLoading(false);
      });
  })

  useEffect(() => {
    RtoDataList();
  }, [selectedTab])

  const columns = [
    {
      field: 'Shift_Date',
      headerName: 'Date',
      flex: 1,
      minWidth: 240,
      valueGetter: (params) => formateDate(params.row?.Shift_Date),
    },
    {
      field: 'Shift_Type',
      headerName: 'Shift',
      flex: 1,
      minWidth: 220,
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            width: '100%',
          }}
        >
          {`${params.row.Shift_Type} (${varFormatTime(`${params.row.Start_Time}-${params.row.End_Time}`, user?.Time_Format)})`}
        </div>
      ),
    },
    {
      field: 'PositionName',
      headerName: 'Position',
      flex: 1,
      minWidth: 140,
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            width: '100%',
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      field: 'AssignmentName',
      headerName: 'Assignment',
      flex: 1,
      minWidth: 80,
    },
    {
      field: 'AbsentReason',
      headerName: 'Reason',
      flex: 1,
      minWidth: 120,
      filterable: false,
    },
    {
      field: 'Status',
      headerName: 'Status',
      flex: 1,
      minWidth: 120,
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            width: '100%',
          }}
        >
          {params.row.Status === 'Q' ? 'Requested' : params.row.Status}
        </div>
      ),
    },
    {
      field: 'Comment',
      headerName: 'Comment',
      flex: 1,
      minWidth: 60,
      renderCell: (params) => (
        params.value ? (
          <div onClick={() => handleShow(params.value)} style={{ cursor: 'pointer' }}>
            <img src='/images/comment.svg' height='20px' width='20px' />
          </div>
        ) : null
      ),
    },
    {
      field: 'Action',
      headerName: 'Action',
      flex: 1,
      minWidth: 60,
      renderCell: (params) => {
        if (params.row.Status === 'Q' && selectedTab === 'current') {
          return (
            <span>
              <button
                onClick={() => DeletePTO(params.row?.Shift_Date, params.row?.Shift_Number)}
                className="btn"
              >
                <DeleteIcon />
              </button>
            </span>
          );
        }
      },
    }
  ];

  const DeletePTO = (date, number) => {
    setOpenModalDelete(true);
    setDeleteBody({
      ShiftDate: date, ShiftNumber: number
    });
  }

  const closeDeletePTO = () => {
    setOpenModalDelete(false)
    setDeleteBody({});
  }

  const deleteItem = () => {
    ApiService.post('/cancelPTO', deleteBody)
      .then((data) => {
        RtoDataList()
        toast.success(data?.message)
        // enqueueSnackbar('success', { variant: 'success' });
        closeDeletePTO()
      })
  }

  const columnsSummary = [
    { field: "name", headerName: "Type", flex: 1, minWidth: 140 },
    { field: "date", headerName: "Start Date", flex: 1, minWidth: 100 },
    { field: "start", headerName: "Start", flex: 1, minWidth: 50 },
    { field: "carried", headerName: "Carried", flex: 1, minWidth: 70 },
    { field: "accrued", headerName: "Accrued	", flex: 1, minWidth: 70 },
    { field: "sold", headerName: "Sold", flex: 1, minWidth: 50 },
    { field: "used", headerName: "Used", flex: 1, minWidth: 50 },
    { field: "planned", headerName: "Planned", flex: 1, minWidth: 70 },
    { field: "available", headerName: "Available", flex: 1, minWidth: 80 },
    // valueGetter: (params) =>
    //   params.row.start != 0 ? params.row.start + 0 - params.row.used + 0 : "",
  ]

  useEffect(() => {
    ApiService.get("/getEmployeeLog/" + user.Emp_Code, {}, "getEmployeeLog")
      .then(({ data }) => {
        setData(data || "");
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  }, []);

  const summaryRes = useMemo(() => {
    return data?.summary?.filter((x) => {
      return (
        x.name.toLowerCase().includes(summarySearch.toLowerCase()) ||
        x.start.toString().includes(summarySearch.toLowerCase())
      );
    });
  }, [summarySearch, data]);

  useEffect(() => {
    if (customData) {
      if (startTime && endTime && startTime < endTime) {
        setCanSubmit(true)
      }
      else {
        setCanSubmit(false)
      }
    }
  }, [customData, startTime, endTime])


  return (
    <>
      <ManagementHeaderNav />
      <Paper className='p-3' style={{ marginTop: "1rem" }}>
        <div>
          <Grid container spacing={2} columns={{ xs: 8, sm: 8, md: 12 }}>
            <Grid item xs={12} >
              <Typography variant='h6'>RTO</Typography>
            </Grid>
          </Grid>
          {pages.includes('MENU_REQ_TIME_OFF') &&
            <Box>
              <form onSubmit={handleSubmit(onSubmit)}>
                <p className='mt-3 mb-2'>Add Time Off Request</p>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={3}>
                    <label style={{ fontSize: '14px' }}>Date</label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        minDate={new Date(moment().add(0, 'days'))}
                        value={date}
                        onChange={(e) => changeDate(e)}
                        className="date-dicker mt-1"
                        sx={{
                          width: '100%',
                          "& .MuiInputBase-root": {
                            height: '48px',
                            fontSize: '14px'
                          }
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>

                  <Grid item xs={12} sm={12} md={3}>
                    <label style={{ fontSize: '14px' }}>Shift</label>
                    <TextField
                      {...register('ShiftCode', { required: "SHIFT  is required" })}
                      className='mt-1 w-100' color='secondary' variant="outlined"
                      select size='small'
                      InputProps={{
                        sx: {
                          height: '48px',
                          fontSize: '14px'
                        }
                      }}
                      onChange={(e) => {
                        setCustomData(e.target.value === 'custom');
                      }}
                      label="Shift"
                    >
                      {allowedShifts.map(type => (
                        <MenuItem value={type.ShiftCode} key={type.ShiftCode}>
                          {type.Shift}
                          {
                            (type.Short_Desc && type.Shift.toLowerCase() !== type.Short_Desc.toLowerCase())
                              ? " ( " + type.Short_Desc + ") "
                              :
                              ""
                          }
                        </MenuItem>
                      ))}
                      {pages && pages.includes('SCHEDULE_CUSTOM_SHIFTS') &&
                        <MenuItem value='custom'>Custom</MenuItem>
                      }
                    </TextField>
                    {errors.ShiftCode && <p style={{ color: 'red' }}>{errors.ShiftCode?.message}</p>}
                  </Grid>

                  <Grid item xs={12} sm={12} md={3}>
                    <label style={{ fontSize: '14px' }}>Type</label>
                    <TextField
                      className='mt-1 w-100' color='secondary' variant="outlined"
                      select size='small'
                      InputProps={{
                        sx: { height: '48px', fontSize: '14px' }
                      }}
                      {...register('SelAbsent', { required: "REASON  is required" })}
                      label="Type"
                    >
                      {Object.entries(abscentReasons)?.map(([key, label]) => {
                        const available = absentReasonDeatils?.[key]?.SO_Info?.data?.available;
                        return (
                          <MenuItem value={key} key={key}>
														{label} {available && `(${available})`}
                          </MenuItem>
                        );
                      })}

                    </TextField>
                  </Grid>


                  {(getValues('SelAbsent') == 'SWAP' || getValues('SelAbsent') == 'SWAP_REASS') &&
                    <Grid item xs={12} sm={12} md={3}>
                      <label style={{ fontSize: '14px' }}>Employee</label>
                      {(getValues('SelAbsent') == 'SWAP' || getValues('SelAbsent') == 'SWAP_REASS')
                        &&
                        <Grid item>
                          {/* <TextField
                            className='mt-1 w-100' color='secondary' variant="outlined"
                            select size='small'
                            InputProps={{
                              sx: {
                                height: '48px',
                                fontSize: '14px'
                              }
                            }}
                            {...register('SelEmp')}
                            label="Employee"
                          >
                            {otherUsers.map(member => (
                              <MenuItem value={member.Emp_Code}>{`${member.EA_Rank} ${member.fullName}`}</MenuItem>
                            ))}
                          </TextField> */}

                          <Autocomplete
                            {...register('SelEmp')}
                            className="mt-0 w-100"
                            options={otherUsers || []}
                            getOptionLabel={(option) => option.EA_Rank + ' ' + option.fullName}
                            onChange={(_, value) => {
                              setValue('SelEmp', value?.Emp_Code || '');
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Employee"
                                variant="outlined"
                                size="small"
                                InputProps={{
                                  ...params.InputProps,
                                  sx: {
                                    height: '48px',
                                    fontSize: '14px',
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    marginTop: '3px',
                                    fontSize: '14px',
                                  },
                                }}
                              />
                            )}
                            isOptionEqualToValue={(option, value) => option.Emp_Code === value}
                            disableClearable
                          />
                        </Grid>
                      }
                    </Grid>
                  }
                </Grid>

                <Grid container spacing={2} className='mt-2'>
                  {customData && (
                    <Grid item xs={12} sm={12} md={3}>
                      <label style={{ fontSize: '14px' }}>From</label>
                      <Box>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <TimePicker
                            timeSteps={{ minutes: 30 }}
                            value={startTime}
                            onChange={(newValue) => setStartTime(newValue)}
                            className='mt-1'
                            sx={{
                              "& .MuiOutlinedInput-input": { color: isErrorTime && 'red' },
                              width: "100%",
                              "& .MuiInputBase-root": {
                                height: '48px',
                                fontSize: '14px'
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Box>
                    </Grid>
                  )}

                  {customData && (
                    <Grid item xs={12} sm={12} md={3}>
                      <label style={{ fontSize: '14px' }}>To</label>
                      <Box>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <TimePicker
                            timeSteps={{ minutes: 30 }}
                            value={endTime}
                            onChange={(newValue) => setEndTime(newValue)}
                            className='mt-1'
                            sx={{
                              width: "100%",
                              scrollbarWidth: "none",
                              "& .MuiOutlinedInput-input": { color: isErrorTime && "red" },
                              "& .MuiInputBase-root": {
                                height: "48px",
                                fontSize: "14px",
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </Box>
                    </Grid>
                  )}
                </Grid>

                {pages.includes('V3_RTO_COMMENT') &&
                  <Grid container spacing={2} className='mt-2'>
                    <Grid item xs={12} md={9} sm={12}>
                      <label className='my-1' style={{ fontSize: '14px' }}>Comment <span style={{ fontSize: '12px', color: '#333' }}>(Only 256 characters are allowed)</span></label>
                      <TextField
                        {...register("comment")}
                        className="w-100"
                        color="secondary"
                        variant="outlined"
                        placeholder='Comment'
                        multiline
                        inputProps={{ maxLength: 256 }}
                        sx={{
                          '& .MuiInputBase-root': {
                            fontSize: '14px !important'
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                }

                <Grid item xs={12} sm={12} md={3}>
                  <div style={{ marginTop: '36px' }} className='d-flex justify-content-end'>
                    <ButtonTheme disabled={saving || (!isValid && !canSubmit)} type='submit' variant="filled" color='primary' className='px-5'>
                      {saving && 'Adding...'}
                      {!saving && 'Add'}
                    </ButtonTheme>
                  </div>
                </Grid>

              </form>


              <Grid items xs={12} sm={12} md={6}>
                <div className="mt-5" style={{ display: 'flex' }}>
                  <div style={{ marginRight: '60px', marginTop: '10px' }}>
                    Rto List
                  </div>
                  <div className={selectedTab == 'current' ? 'tab-active' : 'tab-white'}
                    onClick={() => setSelectedTab('current')}>
                    Current
                  </div>
                  <div className={selectedTab == 'past' ? 'tab-active mx-3' : 'tab-white mx-3'}
                    onClick={() => setSelectedTab('past')}>
                    Past
                  </div>
                </div>
              </Grid>

              {loading && (
                <Box className='d-flex flex-column align-items-center justify-content-center' style={{ height: 200, width: "100%" }}>
                  <CircularProgress />
                </Box>
              )}

              {rtoData.length > 0 && !loading &&
                <Grid item xs={12} sm={12} lg={12}>
                  <Box sx={{
                    marginTop: '10px ',
                  }}>
                    <DataGrid
                      rows={rtoData}
                      columns={columns}
                      checkboxSelection={false}
                      sortingMode='client'
                      rowSelection={false}
                      initialState={{
                        pagination: {
                          paginationModel: {
                            pageSize: 5,
                          },
                        },
                      }}
                      pageSizeOptions={[5]}
                    />
                  </Box>
                </Grid>
              }

              {/* <div className='mt-4'>
                {!loading && rtoData.length == 0 && <div className='d-flex align-items-center' style={{ height: 110 }}>
                  <EmptyState />
                </div>}
              </div> */}

							{!loading && rtoData.length == 0 &&
							<div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 200, width: "100%" }}>
                              <img src='/images/blur-logo.png' style={{ height: 100}} />
                              <span className='mt-4' style={{ color: '#555555' }}>
                                No RTO List Found
                              </span>
                            </div>}

              {data ?
                <Grid item xs={12} sm={12} lg={12}>
                  <Box sx={{
                    height: '50vh !important',
                    border: '1px solid #cccccc !important',
                    padding: '10px',
                    marginTop: '10px ',
                    borderRadius: '8px',
                    overflowY: 'scroll',
                    '@media (max-width: 600px)': {
                      height: 'fit-content !important',
                    },
                  }}>
                    <p className="fw-600 fs-18 mt-1">
                      Accrual Summary
                    </p>
                    <MyTable
                      rows={summaryRes || []}
                      columns={columnsSummary}
                      checkboxSelection={false}
                      hideFooter={true}
                      useSearch={(e) => setSummarySearch(e)}
                      sx={{
                        height: '100%',
                        overflow: 'auto',
                      }}
                    />
                  </Box>
                </Grid>
                : ""
              }
            </Box>
          }

          <DeleteConfirmation openModal={openModalDelete} acceptFunction={deleteItem} rejectFunction={closeDeletePTO} />
          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Comment</Modal.Title>
            </Modal.Header>
            <Modal.Body className='pb-4'>{selectedComment || 'No any Comments'}</Modal.Body>
          </Modal>
        </div>
      </Paper>
    </>
  );
}
